import { Trans } from "@lingui/macro";
import { useMediaQuery, useTheme } from "@mui/material";
import { UiBox, UiButton, UiTypography } from "@smp/ui";
import { testAppendAttr, textCurrencySymbolGet } from "@smp/utils";

import { useContextDialogPurchase } from "../../../context";
import { Composition } from "./composition";
import { Description } from "./description";
import { useStyles } from "./details.css";
import { PlanProductAdditions } from "./plan_product_additions";

export const Details = () => {
  const classes = useStyles();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const {
    actions: { purchase },
    state: { isPurchasing, productList, productSelected, productTrial },
  } = useContextDialogPurchase();

  const oneMonthPeriodProduct = productList?.find(
    (product) => product.period_length === 1 && product.period_units === 7,
  );

  const product = productTrial || productSelected;

  const isOneYearPeriodPlanProduct = !!(
    product.type === "plan-product" &&
    product.period_length === 1 &&
    product.period_units === 8
  );

  return (
    <UiBox flexGrow={0} width={isMobile ? "100%" : 330}>
      <UiBox
        display="flex"
        flexDirection="column"
        height="100%"
        {...testAppendAttr("id", `purchase_details`)}
      >
        <UiBox
          display="flex"
          flexDirection="column"
          className={classes.receipt_top}
          flexGrow={1}
          p={3}
          paddingTop={4}
        >
          <UiBox display="flex">
            <UiTypography variant="h5">
              <Trans>Payment details</Trans>
            </UiTypography>
            {isOneYearPeriodPlanProduct && (
              <UiBox display="flex" flexGrow={1} justifyContent="flex-end">
                <UiTypography className={classes.discount_reminder} noWrap>
                  <Trans>
                    __dialog_purchase.prepare.details__Pay Yearly & Save up to{" "}
                    {33}%
                  </Trans>
                </UiTypography>
              </UiBox>
            )}
          </UiBox>
          <UiBox className={classes.divider} />
          <Description product={product} />
          <Composition product={product} />
          <UiBox className={classes.divider} />
          <UiBox display="flex" flexDirection="row" mb={2}>
            <UiBox flexGrow={1}>
              <UiTypography variant="h5">
                <Trans>To payment:</Trans>
              </UiTypography>
            </UiBox>
            <UiBox display="flex" flexGrow={0} textAlign="right">
              {isOneYearPeriodPlanProduct && oneMonthPeriodProduct && (
                <UiTypography
                  className={classes.discount_price_text}
                  color="textSecondary"
                  noWrap
                  variant="h5"
                >
                  <s>{(oneMonthPeriodProduct.price * 12).toFixed(0)}</s>
                </UiTypography>
              )}
              <UiTypography variant="h5">
                {product.price} {textCurrencySymbolGet(product.currency)}
              </UiTypography>
            </UiBox>
          </UiBox>
          {product.type === "plan-product" && (
            <PlanProductAdditions productPlanProduct={product} />
          )}
          <UiBox>
            <UiButton
              {...testAppendAttr("id", `purchase_go_to_payment`)}
              color="primary"
              fullWidth
              isLoading={isPurchasing}
              onClick={purchase}
              variant="contained"
            >
              <Trans>Go to the payment</Trans>
            </UiButton>
          </UiBox>
        </UiBox>
        <UiBox className={classes.receipt_bottom} />
      </UiBox>
    </UiBox>
  );
};
